import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Stock = ({ primary, user }) => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [msg, setMsg] = useState({ text: '', type: '' });
  const [lcos, setLcos] = useState([]);
  const [form, setForm] = useState({
    serial_number: '',
    gpon_serial: '',
    notes: '',
    lco_id: ''
  });

  const showMsg = (text, type = 'success') => {
    setMsg({ text, type });
    setTimeout(() => setMsg({ text: '', type: '' }), 4000);
  };

  const inp = { width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '13px', boxSizing: 'border-box', outline: 'none' };
  const lbl = { fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '5px' };

  useEffect(() => {
    loadDevices();
    loadLcos();
  }, []);

  const loadDevices = async () => {
    try {
      const res = await axios.get('/api/devices/preregistered');
      setDevices(res.data.devices || []);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  const loadLcos = async () => {
    try {
      const res = await axios.get('/api/users?role=lco_admin');
      setLcos(res.data.users || []);
    } catch(e) { console.error(e); }
  };

  const handleAdd = async () => {
    if (!form.serial_number.trim()) { showMsg('Serial number is required', 'error'); return; }
    try {
      await axios.post('/api/devices/preregister', form);
      showMsg('ONT pre-registered successfully!');
      setShowAdd(false);
      setForm({ serial_number: '', gpon_serial: '', notes: '', lco_id: '' });
      loadDevices();
    } catch(e) { showMsg(e.response?.data?.message || 'Failed', 'error'); }
  };

  const handleDelete = async (id, serial) => {
    if (!window.confirm('Remove ' + serial + ' from stock?')) return;
    try {
      await axios.delete('/api/devices/' + id);
      showMsg('Removed from stock');
      loadDevices();
    } catch(e) { showMsg('Failed to remove', 'error'); }
  };

  const statusColor = {
    pending: { bg: '#fef3c7', color: '#92400e', label: '⏳ Pending' },
    registered: { bg: '#dbeafe', color: '#1e40af', label: '📡 Registered' },
    active: { bg: '#dcfce7', color: '#166534', label: '✅ Active' },
    unknown: { bg: '#f1f5f9', color: '#475569', label: '❓ Unknown' }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px' }}>
        <div>
          <h1 style={{ margin: '0 0 4px', fontSize: '24px', fontWeight: '800', color: '#0f172a' }}>📦 ONT Stock</h1>
          <p style={{ margin: 0, color: '#64748b', fontSize: '14px' }}>Pre-register ONTs before deployment</p>
        </div>
        <button onClick={() => { setShowAdd(!showAdd); setForm({ serial_number: '', gpon_serial: '', notes: '', lco_id: '' }); }}
          style={{ padding: '10px 20px', background: showAdd ? '#ef4444' : primary, color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontSize: '14px', fontWeight: '700' }}>
          {showAdd ? '✕ Cancel' : '+ Add ONT'}
        </button>
      </div>

      {msg.text && (
        <div style={{ background: msg.type === 'error' ? '#fef2f2' : '#ecfdf5', border: `1px solid ${msg.type === 'error' ? '#fecaca' : '#bbf7d0'}`, color: msg.type === 'error' ? '#dc2626' : '#16a34a', padding: '12px 16px', borderRadius: '10px', marginBottom: '16px', fontSize: '14px', fontWeight: '500' }}>
          {msg.type === 'error' ? '⚠️' : '✅'} {msg.text}
        </div>
      )}

      {showAdd && (
        <div style={{ background: 'white', borderRadius: '16px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', border: '1px solid #f1f5f9', marginBottom: '24px' }}>
          <h3 style={{ margin: '0 0 20px', fontSize: '16px', fontWeight: '700', color: '#0f172a' }}>📦 Pre-Register ONT</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
            <div>
              <label style={lbl}>ONT Serial Number *</label>
              <input style={inp} value={form.serial_number} onChange={e => setForm({...form, serial_number: e.target.value.toUpperCase()})} placeholder="e.g. HWTC5E23449C" />
            </div>
            <div>
              <label style={lbl}>GPON Serial (printed on label)</label>
              <input style={inp} value={form.gpon_serial} onChange={e => setForm({...form, gpon_serial: e.target.value})} placeholder="e.g. HWTC5E23449C" />
            </div>




            <div>
              <label style={lbl}>Assign to LCO</label>
              <select style={inp} value={form.lco_id} onChange={e => setForm({...form, lco_id: e.target.value})}>
                <option value=''>-- Select LCO (optional) --</option>
                {lcos.map(l => <option key={l._id} value={l._id}>{l.name} ({l.lco_id || l.email})</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>Notes</label>
              <input style={inp} value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} placeholder="Any notes" />
            </div>
          </div>
          <div style={{ marginTop: '16px', padding: '12px', background: '#f0fdf4', borderRadius: '8px', border: '1px solid #bbf7d0', fontSize: '13px', color: '#166534' }}>
            💡 Once ONT connects to ACS, it will be automatically matched by serial number and provisioned.
          </div>
          <div style={{ display: 'flex', gap: '10px', marginTop: '18px' }}>
            <button onClick={handleAdd} style={{ padding: '11px 24px', background: primary, color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '700', fontSize: '14px' }}>
              💾 Pre-Register ONT
            </button>
            <button onClick={() => setShowAdd(false)} style={{ padding: '11px 20px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '24px' }}>
        {[
          { label: 'Total Stock', value: devices.length, color: '#6366f1', bg: '#eef2ff' },
          { label: 'Pending', value: devices.filter(d => d.registration_status === 'pending').length, color: '#f59e0b', bg: '#fffbeb' },
          { label: 'Active', value: devices.filter(d => d.registration_status === 'active').length, color: '#10b981', bg: '#ecfdf5' }
        ].map(s => (
          <div key={s.label} style={{ background: 'white', borderRadius: '14px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', border: '1px solid #f1f5f9', display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: s.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', fontWeight: '800', color: s.color }}>{s.value}</div>
            <div style={{ fontSize: '13px', color: '#64748b', fontWeight: '600' }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Device List */}
      <div style={{ background: 'white', borderRadius: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', border: '1px solid #f1f5f9', overflow: 'hidden' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>Loading...</div>
        ) : devices.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8' }}>
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>📦</div>
            <div style={{ fontSize: '16px', fontWeight: '600', color: '#475569' }}>No ONTs in stock</div>
            <div style={{ fontSize: '14px', marginTop: '4px' }}>Click "+ Add ONT" to pre-register</div>
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                {['Serial Number', 'GPON Serial', 'Notes', 'Status', 'Added', 'Actions'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #f1f5f9' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {devices.map(d => {
                const st = statusColor[d.registration_status] || statusColor.unknown;
                return (
                  <tr key={d._id} style={{ borderBottom: '1px solid #f8fafc' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                    onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ fontFamily: 'monospace', fontSize: '13px', fontWeight: '700', color: '#0f172a', background: '#f1f5f9', padding: '3px 8px', borderRadius: '6px', display: 'inline-block' }}>{d.serial_number}</div>
                    </td>
                    <td style={{ padding: '12px 16px', fontSize: '12px', color: '#64748b', fontFamily: 'monospace' }}>{d.gpon_serial || '—'}</td>
                    <td style={{ padding: '12px 16px', fontSize: '13px', color: '#64748b' }}>{d.notes || '—'}</td>
                    <td style={{ padding: '12px 16px' }}>
                      <span style={{ background: st.bg, color: st.color, padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '700' }}>{st.label}</span>
                    </td>
                    <td style={{ padding: '12px 16px', fontSize: '12px', color: '#94a3b8' }}>{new Date(d.createdAt).toLocaleDateString('en-IN')}</td>
                    <td style={{ padding: '12px 16px' }}>
                      <button onClick={() => handleDelete(d._id, d.serial_number)}
                        style={{ padding: '5px 10px', background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: '7px', cursor: 'pointer', fontSize: '12px', fontWeight: '700' }}>
                        🗑️
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Stock;
